module.exports = __webpack_public_path__ + "static/media/shopify2.13898882.png";